import { stakingApi } from './api';

export const stakingService = {
  getHistoryTransaction: (params: object): any => {
    return stakingApi.get('/v1/staking-scan', { params }).then((data) => Promise.resolve(data));
  }
};
